import React from 'react'
import Textfield from 'britive-design-system/core/components/textfield'
import Typography from 'britive-design-system/core/components/typography'
import Textarea from 'britive-design-system/core/components/textarea'

const WebAuthNModelContent = ({
  webAuthnName,
  setWebAuthnName,
  webAuthnDescription,
  setWebAuthnDescription,
}) => {
  return (
    <div className="user-mfa-registration-modal">
      <Typography variant="heading6">
        {`Please fill the details to register your device`}
      </Typography>
      <br />
      <Textfield
        value={webAuthnName}
        label={'Device Name'}
        onChange={e => setWebAuthnName(e.target.value)}
      />
      <br />
      <Textarea
        label="Description"
        value={webAuthnDescription}
        onChange={e => setWebAuthnDescription(e.target.value)}
      />
      <br />
    </div>
  )
}

export default WebAuthNModelContent
